import { client } from './apollo';
import { REQUEST_UPLOAD_URL } from '../graphql/feedback';

// Faz upload de um File usando presigned URL emitida pela API.
// Retorna { storageKey, mimeType, sizeBytes }.
export const uploadEvidenceFile = async (file, kind) => {
  if (!file) throw new Error('Arquivo ausente');

  const { data } = await client.mutate({
    mutation: REQUEST_UPLOAD_URL,
    variables: {
      filename: file.name,
      mimeType: file.type,
      sizeBytes: file.size,
      kind,
    },
  });

  const presign = data?.requestUploadUrl;
  if (!presign?.uploadUrl) throw new Error('Falha ao obter URL de upload');

  const putResponse = await fetch(presign.uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  });

  if (!putResponse.ok) {
    throw new Error(`Upload falhou (${putResponse.status})`);
  }

  return {
    storageKey: presign.storageKey,
    mimeType: file.type,
    sizeBytes: file.size,
  };
};
